import { createAction } from "@reduxjs/toolkit";
import {
  GET_AMENITY,
  GET_AMENITY_V2,
  GET_AMENITIES,
  GET_BUILDING_AMENITIES_V2,
  ADD_AMENITIES,
  ADD_AMENITIES_V2,
  UPDATE_AMENITY_V2,
  UPLOAD_AMENITY_WAIVER_DOC,
  UPLOAD_AMENITY_IMAGES_BATCH_V2,
  SYNC_AMENITY_IMAGES_V2,
  EDIT_AMENITIES,
  FILTER_AMENITIES,
  MODAL_SHOW_AMENITY_DETAIL,
  CLEAR_AMENITY,
  CLEAR_ERROR,
  SET_AMENITY_TYPE,
  REMOVE_AMENITY,
  GET_AMENITY_TYPES,
  SET_FILTERED_AMENITIES,
  CLEAR_FILTERED_AMENITIES,
  CLEAR_AMENITIES
} from "../constants";

export const setAmenityType = createAction(SET_AMENITY_TYPE);
export const getAmenity = createAction(GET_AMENITY);
export const getAmenityV2 = createAction(GET_AMENITY_V2);
export const getAmenities = createAction(GET_AMENITIES);
export const getBuildingAmenitiesV2 = createAction(GET_BUILDING_AMENITIES_V2);
export const addAmenities = createAction(ADD_AMENITIES);
export const addAmenitiesV2 = createAction(ADD_AMENITIES_V2);
export const updateAmenityV2 = createAction(UPDATE_AMENITY_V2);
export const uploadAmenityWaiverDoc = createAction(UPLOAD_AMENITY_WAIVER_DOC);
export const uploadAmenityImagesBatchV2 = createAction(UPLOAD_AMENITY_IMAGES_BATCH_V2);
export const syncAmenityImagesV2 = createAction(SYNC_AMENITY_IMAGES_V2);
export const editAmenities = createAction(EDIT_AMENITIES);
export const clearAmenity = createAction(CLEAR_AMENITY);
export const filterAmenities = createAction(FILTER_AMENITIES);
export const modalVisibility = createAction(MODAL_SHOW_AMENITY_DETAIL);
export const clearAmenityError = createAction(CLEAR_ERROR);
export const removeAmenity = createAction(REMOVE_AMENITY);
export const getAmenityTypes = createAction(GET_AMENITY_TYPES);
export const setFilteredAmenities = createAction(SET_FILTERED_AMENITIES);
export const clearFilteredAmenities = createAction(CLEAR_FILTERED_AMENITIES);
export const clearAmenities = createAction(CLEAR_AMENITIES);

export default {
  getAmenity,
  getAmenityV2,
  removeAmenity,
  setAmenityType,
  clearAmenityError,
  clearAmenity,
  addAmenities,
  addAmenitiesV2,
  updateAmenityV2,
  uploadAmenityWaiverDoc,
  uploadAmenityImagesBatchV2,
  syncAmenityImagesV2,
  editAmenities,
  getAmenities,
  getBuildingAmenitiesV2,
  filterAmenities,
  modalVisibility,
  clearAmenities
};
